/*eslint no-undef: "error"*/
import { Route, Navigate } from "react-router-dom";

const CheckAuth = () => {
  const auth = localStorage.getItem("auth");
  var currentPath = window.location.pathname;
  if (auth !== "" && auth !== null) {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const expiryDate = readData.userdata.exp;
    const currentDateData = new Date();
    const currentDate = Date.parse(currentDateData);
    const currentDateString = currentDate / 1000;
    if (currentDateString > expiryDate) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("auth");
      localStorage.removeItem("customerData");
      localStorage.removeItem("workData");
      localStorage.removeItem("techData");
      localStorage.removeItem("jobCountData");
      localStorage.removeItem("siteID");
      localStorage.removeItem("unsyu");
      localStorage.removeItem("profiledata");
      localStorage.removeItem("permissions");
      localStorage.removeItem("notiCountData");
      // localStorage.removeItem("splashShown");
      // localStorage.removeItem("showSplashDate");
      <Route path="*" element={<Navigate to="/" replace />} />;
    } else {
      if (currentPath === "/") {
        const permissionsdata = localStorage.getItem("permissions");
        const permissionsreadData = JSON.parse(permissionsdata);
        const filteredData = permissionsreadData.filter((obj) => {
          return (
            obj.PermissionCode === "VALIDATE_JOB" ||
            obj.PermissionCode === "AUTHORIZE_JOB" ||
            obj.PermissionCode === "CREATE_JOB"
          );
        });
        if (filteredData.length > 0) {
          if (
            filteredData[0].PermissionCode === "VALIDATE_JOB" ||
            filteredData[0].PermissionCode === "AUTHORIZE_JOB"
          ) {
            window.location = "/job-view";
          } else {
            window.location = "/create-job";
          }
        }
      }
    }
  } else {
    if (auth === "" || auth === null) {
      <Route path="*" element={<Navigate to="/" replace />} />;
    }
  }
};

export default CheckAuth;
